export default "__VITE_ASSET__CFpdM7fd__"